import { Routes, BrowserRouter, Route, HashRouter } from "react-router-dom";
import Signin from "./components/Signin";
import Errorpage from "./components/Errorpage";
import Superadmin from "./components/Superadmin";
import PrivateOutlet from "./components/PrivateOutlet";
import Landing from "./components/LandingPage";
import Admin from "./components/admin";
// import Student from "./components/Student/Student";
import Faculty from "./components/Faculty/Faculty";
import Coordinator from "./components/Coordinator/Coordinator";
import Profile from "./components/Profile/Profile";
import FacultyGroup from "./components/FacultyGroup/FacultyGroup";
import FilesView from "./components/FilesView/FilesView";
import AdminAddSubject from "./components/adminAddSubject/AdminAddSubject";
import Loading from "./components/Loading/Loading";
import AppLayout from "./components/AppLayout";
import FacultyDashboard from "./components/FacultyDashboard/FacultyDashboard";
import FacultyFilesView from "./components/FacultyDashboard/FacultyFilesView";
import AddBranch from "./components/Superadmin/NewWork/AddBranch";
import AddAdmin from "./components/Superadmin/AddAdmin";
import StudentNew from "./components/Student/StudentNew";
const AppRoutes = () => (
  <Routes>
    <Route element={<AppLayout />}>
      <Route exact path="/" element={<Landing />} />
      <Route exact path="/signin" element={<Signin />} />
      <Route path="/loading" element={<Loading />} />
      {/* Protected routes */}
      <Route element={<PrivateOutlet />}>
        <Route path="super-admin" element={<Superadmin />} />
        {/* <Route path="super-admin/addbranch/:id" element={<AddBranches />} /> */}
        <Route path="super-admin/branch/:id" element={<AddAdmin />} />
        <Route path="super-admin/addbranch/:id" element={<AddBranch />} />
        <Route path="admin" element={<Admin />} />
        <Route path="adminAddSubject" element={<AdminAddSubject />} />
        {/* <Route path="student" element={<Student />} /> */}
        <Route path="student" element={<StudentNew/>}/>
        {/* <Route path="faculty" element={<Faculty />} /> */}
        <Route path="coo" element={<Coordinator />} />
        <Route path="profile" element={<Profile />} />
        {/* ?exam&category query params */}
        <Route path="files/subjects/:batch/:section" element={<FacultyGroup />} />
        {/* /subjectid/sectionid/2021/facId/fid */}
        <Route path="files/:subId/:secId/:batch/:facId/:fId" element={<FilesView />} />
        <Route path="files/:subId/:secId/:batch/:facId" element={<FilesView />} />
        <Route path="faculty/files/:subId/:fId" element={<FacultyFilesView />} />
        <Route path="faculty/files/:subId" element={<FacultyFilesView />} />
        <Route path="faculty" element={<FacultyDashboard />} />
      </Route>
      <Route path="*" element={<Errorpage />} />
    </Route>
  </Routes>
)
function App() {
  if (!window.cordova) {
    return (
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    )
  }
  return (
    <HashRouter>
      <AppRoutes />
    </HashRouter>
  )
}

export default App;
